import React from 'react';

import EventDateFilter from '../Filters/EventDateFilter';

const LeagueFilters = (props) => {
    const {
        search,
        handleFilterClick,
        state,
        _this,
        filterInputs,
    } = props;

    const { filters = {} } = search;

    const commonFilterProps = {
        filters,
        filterInputs,
        handleFilterClick,
        filterModal: state.filterModal,
        closeModals: _this.closeModals,
        handleFilterSubmit: _this.handleFilterSubmit,
        clearFilters: _this.clearFilters,
        handleFilterUpdate: _this.handleFilterUpdate,
    };

    return (
        <React.Fragment>
            <EventDateFilter
                {...commonFilterProps}
                data-testid="search.leagues.filter.date"
            />
        </React.Fragment>
    );
};

export default LeagueFilters;
